import {
  SET_ERROR, SET_INFO,
  SET_SUCCESS, CLEAR,
} from './actionTypes';

export const setError = (error) => ({ type: SET_ERROR, error });
export const setSuccess = (success) => ({ type: SET_SUCCESS, success });
export const setInfo = (info) => ({ type: SET_INFO, info });
export const clear = () => ({ type: CLEAR });
